import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutComponent } from './layout/layouts/empty/empty.component';


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    //{path: '', pathMatch : 'full', redirectTo: 'example'},
    {path: '', pathMatch : 'full', redirectTo: 'main/policyselection/list'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    //{path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'example'},
    //{path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'example'},
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'main/policyselection/list'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'confirm-mail', loadChildren: () => import('app/modules/auth/confirm-mail/confirm-mail.routes')},
            {path: 'privacy-policy', loadChildren:() => import('app/main/authentication/privacy-policy/privacy-policy.routes')},
            {path: 'terms-of-use', loadChildren:() => import('app/main/authentication/terms-condition/terms-conditions.routes')}
        ]
    },


    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: EmptyLayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'authentication', loadChildren: () => import('./main/authentication/authentication.module').then(m => m.AuthenticationModule)},
            {path: 'recoversecuritycode', loadChildren: () => import('app/main/authentication/confirm-recover-security-code/recoversecuritycode.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

     // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent, 
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes') },
            { path: 'master', loadChildren: () => import('./main/master/master.module').then(m => m.MasterModule) },
            { path: 'main', loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
            { path: 'main/company/list', loadChildren: () => import('./main/company/company.module').then(m => m.CompanyModule) },
            { path: 'user', loadChildren: () => import('./main/user/user.module').then(m => m.UserMainModule) },
            { path: 'system/list', loadChildren: () => import('./main/user/system/system.user.module').then(m => m.SystemUserModule) },
            { path: 'bsexpert/list', loadChildren: () => import('./main/user/bsexpert/bsexpert.user.module').then(m => m.BsExpertModule) },
            { path: 'main/assessment/list', loadChildren: () => import('./main/assessment/assessment.module').then(m => m.AssessmentModule) },
            { path: 'subscription/list', loadChildren: () => import('./main/subscription/subscription.module').then(m => m.SubscriptionModule) },
            { path: 'main/clientsubscription/list', loadChildren: () => import('./main/subscription/subscription.module').then(m => m.SubscriptionModule) },
            { path: 'main/clientsubscription/edit', loadChildren: () => import('./main/subscription/subscription.module').then(m => m.SubscriptionModule) },
            { path: 'main/clientsubscription/add', loadChildren: () => import('./main/subscription/subscription.module').then(m => m.SubscriptionModule) },
            { path: 'main/allcompanyproject/list', loadChildren: () => import('./main/infosec/infosec.module').then(m => m.InfoSecModule) },
            { path: 'main/profile', loadChildren: () => import('./main/myprofile/myprofile.module').then(m => m.MyProfileModule) },
            { path: 'main/dashboard/client-user', loadChildren: () => import('./main/reports/reports.module').then(m => m.ReportsModule) },
            
        ]
    }
];
